/**
 * Column sorter configurations for equipment table
 * Used by useEquipmentFilters hook for client-side sorting
 */
export const columnSorters = [
  {
    key: "title",
    sorter: (a, b) => a.title.localeCompare(b.title)
  },
  {
    key: "quantity",
    sorter: (a, b) => a.quantity - b.quantity
  },
  {
    key: "category",
    sorter: (a, b) => a.category.localeCompare(b.category)
  },
  {
    key: "assignedExperiences",
    sorter: (a, b) => a.assignedExperiences - b.assignedExperiences
  },
  {
    key: "upcomingBookings",
    sorter: (a, b) => (a.upcomingBookings || 0) - (b.upcomingBookings || 0)
  },
  {
    key: "status",
    sorter: (a, b) => (a.status || "").localeCompare(b.status || "")
  }
]
